import { app } from '../utils/store'
import "lightgallery.js";

export default class LightBox{
    constructor({ element, images }){
        this.element = element
        this.images = images

        this.create({ entry: this.element, images: this.images })
    }

    create({ entry, images }) {
        document.body.classList.add(`lg-${entry.getAttribute('data-lightbox')}`);

        let lightbox = lightGallery(entry, {
            mode: 'lg-fade',
            startClass: 'lg-start-fade',
            keypress: true,
            controls: true,
            download: false,
            counter: false,
            enableDrag: true,
            enableTouch: false,
            enableSwipe: true,
            subHtmlSelectorRelative: true,
            useLeft: true,
            hideControlOnEnd: true,
        })

        entry.addEventListener('onBeforeOpen', () => {
            app.header.classList.add('lg-active')
            document.body.classList.toggle('overflow-hidden')
        })

        entry.addEventListener('onBeforeClose', () => {
            app.header.classList.remove('lg-active')
            document.body.classList.toggle('overflow-hidden')
        })

        this.images.forEach((image) => {
            image.onclick = (event) => {
                let target = event.target.getAttribute('data-src')
                document.querySelector(`.lightbox [data-src="${target}"]`).click()
            }
        })
    }
}
